import { atom } from "recoil";
export const crmFilteredData = atom({
  key: "crm-filter-file",
  default: null,
});
